module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('v-navigation-drawer', {
    staticClass: "pb-0",
    attrs: {
      "persistent": "",
      "height": "100%",
      "clipped": "",
      "absolute": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": 'https://randomuser.me/api/portraits/men/38.jpg',
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("User")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v(" Categories ")]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.text,
      staticClass: "mt-3"
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v(" Settings ")]), _vm._v(" "), _vm._l((_vm.items2), function(item) {
    return _c('v-list-tile', {
      key: item.text,
      staticClass: "mt-3",
      attrs: {
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "grey--text text--darken-1"
    }, [_vm._v(_vm._s(item.icon) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-title', {
      staticClass: "grey--text text--darken-1"
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")])], 1)
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "fixed": ""
    }
  }, [_c('v-toolbar-title', [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v("\n      Logo\n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-menu', {
    attrs: {
      "bottom": "",
      "right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text--darken-2",
    attrs: {
      "left": ""
    }
  }, [_vm._v("account_circle")]), _vm._v("\n          My Account\n        ")], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "color": "white"
    }
  }, _vm._l((_vm.account), function(item) {
    return _c('v-list-tile', {
      key: item.title
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)
  }), 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c3d85f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Components/NavBar.vue
// module id = 1220
// module chunks = 2 9